import { FormattedMessage } from 'react-intl';
import { routes } from '@/shared/routes';
import BrandLink from './BrandLink';

export default function AuthBrandPanel() {
  return (
    <aside
      aria-label="Skip Visa Queue"
      className="hidden min-h-[100dvh] flex-col justify-between bg-brand-950 px-10 py-12 text-white lg:flex xl:px-16 xl:py-14"
    >
      <BrandLink tone="inverse" />
      <div className="max-w-md pb-12">
        <span className="mb-7 block h-1 w-14 bg-accent-400" aria-hidden="true" />
        <p className="text-4xl font-semibold leading-tight">
          <FormattedMessage id="auth.layout.promise" />
        </p>
        <p className="mt-5 max-w-sm text-base leading-7 text-brand-100">
          <FormattedMessage id="auth.layout.guarantee" />
        </p>
      </div>
      <a
        href={routes.root}
        className="text-xs font-medium text-brand-200 transition-colors hover:text-white"
      >
        {window.location.hostname}
      </a>
    </aside>
  );
}
